import { once } from 'ramda';
import { UserSyncArguments } from 'user-sync/index.types';
import { getUserSyncURL } from './utils';

const ID = '24';
const IABid = [13];

export const createPixel = (consentData?: string | null): HTMLImageElement => {
  const img = document.createElement('img');
  img.style.display = 'none';
  if (consentData) {
    img.src = `https://ap.lijit.com/pixel?gdpr=1&gdpr_consent=${consentData}&redir=${getUserSyncURL(
      ID,
    )}$UID`;
  } else {
    img.src = `https://ap.lijit.com/pixel?gdpr=0&gdpr_consent=&redir=${getUserSyncURL(ID)}$UID`;
  }

  return img;
};

export default once(({ userSyncPixelsManager, fastdom, context }: UserSyncArguments): void =>
  userSyncPixelsManager.create(context.gdprConsent, ID, IABid, () => {
    if (context.gdprConsent.consent?.gdprApplies) {
      const img = createPixel(context.gdprConsent.consent.tcString);
      fastdom.mutate(function userSyncSovrnCMPAddElement() {
        document.body.appendChild(img);
      });
    } else {
      const img = createPixel();
      fastdom.mutate(function userSyncSovrnAddElement() {
        document.body.appendChild(img);
      });
    }
  }),
);
